/*
 * Noibu A/B test: Men's Belts material chips
 * Noibu test id 307, flag key 4365-men-s-belts-material-chips
 * Variations: original-tiles (control) | material-chips (B)
 *
 * Shape of Noibu's implementation snippet (render() switch):
 *
 *   const client = window.NoibuFeatureFlag.getClient();
 *   const { variation } = client.getStringDetails('4365-men-s-belts-material-chips', 'original-tiles');
 *   switch (variation) {
 *     case 'material-chips': // show variation B
 *     default:               // control
 *   }
 *
 * SDK note: the details object carries the arm in `variant` (and `value`), not
 * `variation`. Destructuring `variation` sends every visitor to the control, so
 * this file reads details.variant || details.variation || details.value.
 *
 * QA override (skips the SDK and the cache):
 *   ?nff_mens_belts_chips=material-chips
 *   ?nff_mens_belts_chips=original-tiles
 */
(function () {
  'use strict';

  var FLAG_KEY = '4365-men-s-belts-material-chips';
  var CONTROL = 'original-tiles';
  var VARIANT_B = 'material-chips';
  var ARMS = [CONTROL, VARIANT_B];
  var QA_PARAM = 'nff_mens_belts_chips';
  var HINT_KEY = 'wk_ab_mens_belts_chips';
  var ATTR_NAME = 'ab_mens_belts_chips';
  var HTML_CLASS = 'wk-chips-b';
  var TIMEOUT_MS = 10000;

  var decided = false;

  function storageSet(value) {
    try { window.localStorage.setItem(HINT_KEY, value); } catch (e) {}
  }

  function report(arm) {
    try {
      if (window.NOIBUJS && typeof window.NOIBUJS.addCustomAttribute === 'function') {
        window.NOIBUJS.addCustomAttribute(ATTR_NAME, arm);
      }
    } catch (e) {}
  }

  function render(arm, opts) {
    if (decided) return;
    decided = true;
    var root = document.documentElement;
    switch (arm) {
      case VARIANT_B:
        root.classList.add(HTML_CLASS);
        break;
      default:
        arm = CONTROL;
        root.classList.remove(HTML_CLASS);
    }
    if (!opts || !opts.qa) storageSet(arm);
    if (window.WKMensBeltsChips && typeof window.WKMensBeltsChips.place === 'function') {
      window.WKMensBeltsChips.place();
    }
    report(arm);
  }

  function armFrom(details) {
    if (!details) return null;
    var arm = details.variant || details.variation || details.value;
    return ARMS.indexOf(arm) > -1 ? arm : null;
  }

  // 1. QA override
  var qa = null;
  try { qa = new URLSearchParams(window.location.search).get(QA_PARAM); } catch (e) {}
  if (qa && ARMS.indexOf(qa) > -1) {
    render(qa, { qa: true });
    return;
  }

  // 2. Ask the SDK once it is ready
  function tryClient() {
    if (decided) return true;
    var ff = window.NoibuFeatureFlag;
    if (!ff || typeof ff.getClient !== 'function') return false;
    try {
      var client = ff.getClient();
      if (!client || typeof client.getStringDetails !== 'function') return false;
      var details = client.getStringDetails(FLAG_KEY, CONTROL);
      var arm = armFrom(details);
      if (details && details.errorCode && /NOT_READY/i.test(String(details.errorCode))) return false;
      render(arm || CONTROL);
      return true;
    } catch (e) {
      return false;
    }
  }

  window.addEventListener('noibuFeatureFlagReady', tryClient);
  window.addEventListener('noibuFeatureFlagError', function () { render(CONTROL); });

  if (!tryClient()) {
    var poll = window.setInterval(function () {
      if (tryClient() || decided) window.clearInterval(poll);
    }, 250);

    function startTimeout() {
      window.setTimeout(function () {
        window.clearInterval(poll);
        render(CONTROL);
      }, TIMEOUT_MS);
    }
    if (document.readyState === 'complete') startTimeout();
    else window.addEventListener('load', startTimeout);
  }
})();
